module.exports = __webpack_public_path__ + "img/balkon03.52c1bab8.webp";